/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { defineComponent as ɵdefineComponent, detectChanges as ɵdetectChanges, renderComponent as ɵrenderComponent, C as ɵC, D as ɵD, E as ɵE, T as ɵT, V as ɵV, b as ɵb, b1 as ɵb1, c as ɵc, cR as ɵcR, cr as ɵcr, e as ɵe, p as ɵp, s as ɵs, t as ɵt, v as ɵv, } from './render3/index';
// clang-format on
//# sourceMappingURL=core_render3_private_export.js.map